import React from "react";

import { Button, Sidebar } from "../../ui";
import { CHROME_WEBSTORE_URL } from "../../../constants";
import MultipleAccountsHelpGuide from "./MultipleAccountsHelpGuide";

type ConnectLinkedinExtensionSidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  isLoading?: boolean;
};

export default function ConnectLinkedinExtensionSidebar({
  isOpen,
  onClose,
  onBack,
  isLoading = false,
}: ConnectLinkedinExtensionSidebarProps) {
  return (
    <Sidebar
      isOpen={isOpen}
      onClose={onClose}
      title="Connect LinkedIn account"
      size="small"
    >
      {isLoading ? (
        <div className="flex items-center justify-center py-10">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-light-grey border-t-brand-blue" />
        </div>
      ) : (
        <div className="space-y-4 text-left">
          <button
            type="button"
            className="inline-flex h-10 w-full items-center justify-center rounded-[8px] border border-border-grey bg-white px-4 text-md text-dark-grey hover:bg-primary"
            data-bypass-plan-gate="true"
            onClick={onBack}
          >
            {"<"} Back
          </button>

          <p className="text-md text-dark-black">
            Connect your LinkedIn account via our Chrome extension.
          </p>

          <div className="rounded-[8px] bg-primary px-4 py-3 text-center text-md text-dark-grey">
            The Chrome extension is only available for Google Chrome
          </div>

          <MultipleAccountsHelpGuide variant="compact" defaultExpanded={false} />

          <Button
            variant="outline"
            size="sm"
            fullWidth
            type="button"
            iconSrc="/icons/chrome.svg"
            showBefore
            iconClassName="h-4 w-4"
            data-bypass-plan-gate="true"
            onClick={() => {
              window.open(
                CHROME_WEBSTORE_URL,
                "_blank",
                "noopener,noreferrer"
              );
            }}
          >
            Install Chrome Extension
          </Button>
        </div>
      )}
    </Sidebar>
  );
}

